import styled from "@emotion/styled";
import { colors } from "../../theme/colors";

const MOBILE_BREAKPOINT = "600px";

export const PageContainer = styled.div`
  min-height: 100vh;
  background-color: ${colors.background.default};
  padding: 40px 20px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${colors.background.secondary};
  border-radius: 12px;
  padding: 40px 60px;
  word-break: break-word;
  overflow-wrap: break-word;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    border-radius: 0;
    padding: 16px;
    min-height: 100vh;
    & p,
    & span,
    & h1,
    & h2,
    & h3,
    & h4,
    & h5,
    & h6,
    & div {
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
`;

export const StickyHeader = styled.div`
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: ${colors.background.secondary};
    padding: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid ${colors.border.light};
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-bottom: 16px;
  }
`;

export const PageTitle = styled.h1`
  font-family: "Sora", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${colors.text.primary};
  text-align: center;
  margin: 0 0 8px 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 20px;
    margin: 0 0 4px 0;
  }
`;

export const DateInfo = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: ${colors.text.secondary};
  text-align: center;
  margin: 0 0 32px 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 12px;
    margin: 0 0 16px 0;
  }
`;

export const Section = styled.div`
  margin-bottom: 24px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-bottom: 16px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: "Sora", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin: 0 0 12px 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 14px;
    margin: 0 0 8px 0;
  }
`;

export const SectionContent = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: ${colors.text.secondary};
  line-height: 1.6;
  margin: 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 13px;
    line-height: 1.5;
  }
`;

export const StepsContainer = styled.div`
  margin-top: 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 12px;
  }
`;

export const TotalFeeContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    justify-content: flex-start;
    margin-top: 16px;
    padding-top: 12px;
  }
`;

export const TotalFeeLabel = styled.span`
  font-family: "Sora", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.text.primary};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 14px;
  }
`;

export const TotalFeeValue = styled.span`
  font-family: "Sora", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin-left: 8px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 14px;
    margin-left: 4px;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 40px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
  }
`;

export const Footer = styled.footer`
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid ${colors.border.light};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 24px;
    padding-top: 16px;
  }
`;

export const FooterDate = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 12px;
  color: ${colors.text.secondary};
  margin: 0 0 8px 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 11px;
    margin: 0 0 6px 0;
  }
`;

export const FooterClinicName = styled.p`
  font-family: "Sora", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.primary.main};
  margin: 0 0 4px 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 12px;
    margin: 0 0 3px 0;
  }
`;

export const FooterContacts = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 12px;
  color: ${colors.text.secondary};
  margin: 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 11px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  text-align: center;
`;

export const ErrorText = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: ${colors.status.error};
  margin: 0;
`;

export const SuccessMessage = styled.div`
  background-color: ${colors.status.activeBg};
  border: 1px solid ${colors.status.success};
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 24px;
  text-align: center;
`;

export const SuccessText = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: ${colors.status.success};
  margin: 0;
`;

// OTP Verification styles (matching Auth pages layout)
export const OtpVerificationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OtpVerificationTitle = styled.h1`
  font-family: "Sora", sans-serif;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
  color: ${colors.text.primary};
`;

export const OtpVerificationSubtitle = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  color: ${colors.text.secondary};
  margin-bottom: 44px;
`;

export const OtpVerificationForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
`;

export const OtpVerificationActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  align-items: center;
  margin-top: 16px;
`;
